import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { useCallback } from 'react';
const exportsApi = buildService('/claim_groups/{id}/project_template_unmapped_exports', {
  only: ['all', 'create', 'show', 'delete']
});
const projectTemplateExportsService = {
  useFetchAll: (setLoading, claimGroupId) => {
    const [exports, setExports, fetchExports] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimGroupId) return [];
        const response = await exportsApi.all(claimGroupId);
        return Array.isArray(response) ? response : [];
      }, [claimGroupId]),
      setLoading,
      initialStateValue: []
    });
    return [exports, setExports, fetchExports];
  },
  useCreate: (setLoading, setExports, exports, claimGroupId) => {
    const createExport = serviceMethods.useCreate({
      callback: useCallback(async projectFields => {
        if (!claimGroupId) return;
        const payload = {
          project_fields: projectFields
        };
        const response = await exportsApi.create(claimGroupId, payload);
        setExports([response, ...exports]);
        return response;
      }, [exports, setExports, claimGroupId]),
      setLoading
    });
    return [createExport];
  },
  usePolling: function (exports, fetchExports) {
    let enabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const hasPendingExports = exports.some(exp => exp.status === 'pending');
    serviceMethods.usePolling({
      callback: fetchExports,
      enabled: enabled && hasPendingExports,
      intervalMs: 7000
    });
  },
  useDelete: (setLoading, setExports, exports, claimGroupId) => {
    const deleteExport = serviceMethods.useDelete({
      callback: useCallback(async exportId => {
        if (!claimGroupId) return;
        await exportsApi.delete(claimGroupId, exportId);
        setExports(exports.filter(exp => exp.id !== Number(exportId)));
      }, [exports, setExports, claimGroupId]),
      setLoading
    });
    return [deleteExport];
  }
};
projectTemplateExportsService.useCrud = (setLoading, claimGroupId) => {
  const [exports, setExports, fetchExports] = projectTemplateExportsService.useFetchAll(setLoading, claimGroupId);
  const [createExport] = projectTemplateExportsService.useCreate(setLoading, setExports, exports, claimGroupId);
  const [deleteExport] = projectTemplateExportsService.useDelete(setLoading, setExports, exports, claimGroupId);
  projectTemplateExportsService.usePolling(exports, fetchExports, true);
  return {
    exports,
    setExports,
    fetchExports,
    createExport,
    deleteExport
  };
};
export default projectTemplateExportsService;